import React from 'react'
import { IconButton, TableCell, TableRow, withStyles } from '@material-ui/core'
import { Field, WatchField } from '../../form'
import classNames from 'classnames'
import FontAwesome from 'react-fontawesome'
import SumField from '../invoice/sumField.component'
import { calculateTotalSum } from '../../utils/invoice.utils'
import { GenericNumberInput } from '../../utils/numberFormat'
import { calculateHoursBetween } from '../../utils/openForWork.utils'
import useDebouncedEffect from '../../utils/useDebouncedEffect'
import { toMinutes } from '../../containers/validate'

const styles = () => ({
  textField: {
    // marginTop: theme.spacing(4),
    fontWeight: 500,
    border: '1px solid gray'
  },
  resize: {
    fontSize: '15px'
  },
  tablecell: {
    padding: '5px'
  }
})

const TimeInputRow = ({
  classes,
  index,
  date,
  startTime,
  endTime,
  totalHour,
  amount,
  additionalInfo,
  totalAmount,
  control,
  removeRow,
  setValue,
  // isEditJournal,
  // rowFields,
  errors,
  watchRowsData,
  clearErrors
}) => {
  const fieldsToWatch = [totalHour, amount, startTime, endTime]
  const rowIndex = index

  // If there is row with blank amount, it can be updated same as first row's amount
  const firstAmount = watchRowsData?.[0]?.amount
  useDebouncedEffect(
    () => {
      if (firstAmount !== undefined && firstAmount !== '') {
        watchRowsData.forEach((row, index) => {
          if ((row.amount === '' || row.amount === undefined) && index !== 0) {
            setValue(`dateTimeRows.${index}.amount`, firstAmount)
          }
        })
      }
    },
    [firstAmount],
    2000
  )

  const timeChanges = () => {
    watchRowsData.forEach((row) => {
      if (toMinutes(row.startTime) < toMinutes(row.endTime)) {
        clearErrors(`dateTimeRows.${rowIndex}.startTime`)
        clearErrors(`dateTimeRows.${rowIndex}.endTime`)
      }
    })
  }

  return (
    <TableRow>
      <TableCell className={classes.tablecell} style={{ width: '130px' }}>
        <Field
          name={date}
          inputType="datepicker"
          control={control}
          className={classNames(classes.textField, classes.resize)}
          showCalendarIcon
        />
      </TableCell>
      <TableCell
        className={classes.tablecell}
        style={{
          width: '75px',
          height:
            errors?.dateTimeRows &&
            (errors?.dateTimeRows[index]?.startTime ||
              errors?.dateTimeRows[index]?.endTime)
              ? '100px'
              : '70px'
        }}
      >
        <Field
          name={startTime}
          inputType="timepicker-selection"
          control={control}
          className={classNames(classes.resize)}
          onChange={timeChanges}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '75px' }}>
        <Field
          name={endTime}
          inputType="timepicker-selection"
          control={control}
          className={classNames(classes.resize)}
          onChange={timeChanges}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '75px' }}>
        {/* <Field
          name={totalHour}
          inputType="textfield"
          control={control}
          className={classNames(classes.textField, classes.resize)}
          inputComponent={GenericNumberInput}
        /> */}
        <WatchField fields={fieldsToWatch} control={control}>
          {(fields) => (
            <SumField
              name={totalHour}
              setValue={setValue}
              className={classNames(classes.textField, classes.resize)}
              control={control}
              watchValue={calculateHoursBetween(
                fields[startTime],
                fields[endTime]
              )}
              isTotalHours={true}
            />
          )}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '75px' }}>
        <Field
          name={amount}
          inputType="textfield"
          control={control}
          className={classNames(classes.textField, classes.resize)}
          inputComponent={GenericNumberInput}
          helperTextStyle={{ marginTop: '0px', height: '0px' }}
        />
      </TableCell>
      <TableCell className={classes.tablecell}>
        <Field
          name={additionalInfo}
          inputType="textfield"
          control={control}
          className={classNames(classes.textField, classes.resize)}
        />
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '100px' }}>
        <WatchField fields={fieldsToWatch} control={control}>
          {(fields) => (
            <SumField
              name={totalAmount}
              setValue={setValue}
              className={classNames(classes.textField, classes.resize)}
              control={control}
              watchValue={calculateTotalSum(
                false,
                fields[totalHour],
                fields[amount],
                0,
                false,
                false
              )}
            />
          )}
        </WatchField>
      </TableCell>
      <TableCell className={classes.tablecell} style={{ width: '50px' }}>
        <IconButton
          aria-label="Delete"
          onClick={() => removeRow(index)}
          key={index}
        >
          <FontAwesome
            name="window-close"
            style={{
              color: '#F67131'
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default withStyles(styles)(TimeInputRow)
